import SeaterSVG from './Seater.svg'
import SleeperSVG from './Sleeper.svg'
import SeatCumSleeperSVG from './SeatCumSleeper.svg'


export const SeaterIcon = (hg, wd) => {
    return <img src={SeaterSVG} alt='SeaterSVG' style={{height:'30px', width:'30px'}}/>
}
export const SleeperIcon = (hg, wd) => {
    return <img src={SleeperSVG} alt='SleeperSVG' style={{height:'30px', width:'30px'}}/>
}
export const SeatCumSleeperIcon = (hg, wd) => {
    return <img src={SeatCumSleeperSVG} alt='SeatCumSleeperSVG' style={{height:'30px', width:'30px'}}/>
}
